import { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';

export const LiliCard = ({ children, className }: { children: ReactElement | ReactElement[]; className?: string }) => (
  <div
    className={twMerge([
      'flex w-full h-full shadow-widgetCard border border-outline-primary-bw-03 bg-surface-primary-bw-00 rounded-[12px]',
      className,
    ])}
  >
    {children}
  </div>
);
